import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CheckoutSummary from '../components/CheckoutSummary';
import CheckoutSummaryMobile from '../components/CheckoutSummaryMobile';

import './GetBoosting/CSS/DivisionBoosting.css';
import './GetBoosting/CSS/Navbar.css';
import DivisionBoosting from './GetBoosting/DivisionBoosting';
import PlacementBoosting from './GetBoosting/PlacementBoosting';
import NetBoosting from './GetBoosting/NetBoosting';
import NormalBoosting from './GetBoosting/NormalBoosting';
import NewNavigation from '../components/NewNavigation';

export default function GetBoosting() {
    const { pathname } = useLocation();
    const containerRef = useRef(null)

    const [price, setPrice] = useState(null);
    const [orderDetails, setOrderDetails] = useState([]);
    const [loadTimer, setLoadTimer] = useState(false);
    const [checkoutTrigger, setCheckoutTrigger] = useState(false);
    const [discountedPrice, setDiscountedPrice] = useState(null);

    useEffect(() => {
        // Reset the checkout trigger when the component mounts
        if (checkoutTrigger) {
            setCheckoutTrigger(false);
        }
    }, [checkoutTrigger]);

    return (
        <div className="w-full mt-8 p-6">
            <div className="mx-auto flex max-w-6xl flex-col gap-8 lg:flex-row">
                {/* Left Side: Main Form */}
                <div className="flex-1 space-y-8">
                  {/* Top Navbar */}
                  <NewNavigation 
                  paths={
                    [['Division Boosting', 'get-boosting/division-boosting'],
                    ['Placement Games', 'get-boosting/placement-games'],
                    ['Net Wins', 'get-boosting/net-wins'],
                    ['Normal Games', 'get-boosting/normal-games']]
                  }
                  />
                  {/* Main content */}
                  {pathname.includes('division-boosting') && (
                      <DivisionBoosting 
                          updatePrice={setPrice} 
                          checkoutInit={checkoutTrigger} 
                          order_details={setOrderDetails} 
                          loading={setLoadTimer}
                      />
                  )}
                  {pathname.includes('placement-games') && (
                      <PlacementBoosting 
                          updatePrice={setPrice} 
                          checkoutInit={checkoutTrigger} 
                          order_details={setOrderDetails} 
                          loading={setLoadTimer}
                      />
                  )}
                  {pathname.includes('net-wins') && (
                      <NetBoosting
                          updatePrice={setPrice} 
                          checkoutInit={checkoutTrigger} 
                          order_details={setOrderDetails} 
                          loading={setLoadTimer}
                      />
                  )}
                  {pathname.includes('normal-games') && (
                      <NormalBoosting
                          updatePrice={setPrice} 
                          checkoutInit={checkoutTrigger} 
                          order_details={setOrderDetails} 
                          loading={setLoadTimer}
                      />
                  )}
                </div>

                {/* Right Side: Checkout Summary */}
                <CheckoutSummary
                    price={price}
                    order_details={orderDetails}
                    checkoutInit={setCheckoutTrigger}
                    loadTimer={loadTimer}
                    discountedPrice={setDiscountedPrice}
                />
            </div>
            {/* Mobile Summary */}
            <CheckoutSummaryMobile price={discountedPrice || 0} targetId="checkout-summary" />
        </div>
    );
}
